export const validator = {
  validate: (formData) => {
    const errors = {};
    const warnings = {};

    const {
      contractorDetails = {},
      siteDetails = {},
      scopeOfWorks = {},
      safeIsolationAndEnvironment = {},
      handoverAndSignatures = {}
    } = formData;

    if (!contractorDetails.companyName?.trim()) {
      errors['contractorDetails.companyName'] = 'Company name is required';
    }
    if (!contractorDetails.engineerName?.trim()) {
      errors['contractorDetails.engineerName'] = 'Lead engineer name is required';
    }
    if (!contractorDetails.tradeCompetencyNo?.trim()) {
      errors['contractorDetails.tradeCompetencyNo'] = 'Trade card / registration ID is required';
    }
    if (!siteDetails.clientName?.trim()) {
      errors['siteDetails.clientName'] = 'Client / Site contact is required';
    }
    if (!siteDetails.siteAddress?.trim()) {
      errors['siteDetails.siteAddress'] = 'Site address is required';
    }
    if (!scopeOfWorks.equipmentMakeModel?.trim()) {
      errors['scopeOfWorks.equipmentMakeModel'] = 'Equipment make and model is required';
    }
    if (!scopeOfWorks.serialNumber?.trim()) {
      errors['scopeOfWorks.serialNumber'] = 'Serial number / Asset ID is required';
    }

    if (safeIsolationAndEnvironment.fGasRecovered === 'Yes - Fully Recovered' && !safeIsolationAndEnvironment.refrigerantTypeAndWeightKg?.trim()) {
      warnings['safeIsolationAndEnvironment.refrigerantTypeAndWeightKg'] = 'Refrigerant weight and F-Gas type should be documented for statutory F-Gas log compliance.';
    }

    if (!handoverAndSignatures.engineerSignature) {
      errors['handoverAndSignatures.engineerSignature'] = 'Lead engineer signature is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      warnings
    };
  }
};

export default validator;
